var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-checkbox',_vm._g(_vm._b({staticClass:"base-simple-checkbox",attrs:{"off-icon":_vm.offIcon,"on-icon":_vm.onIcon,"indeterminate-icon":_vm.indeterminateIcon,"ripple":false}},'v-simple-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }